import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { constants } from 'src/app/shared/common/contants';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { AttributeMappingConfigService } from 'src/app/shared/services/attribute-mapping-config.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { ReportlinksserviceService } from '../../reportlinks/reportlinksservice.service';
import { EtlService } from '../../vault-data-migration-etl/etl.service';
import { CommonPopupSearchComponent } from '../../common-popup-search/common-popup-search.component';
import { SqlEditorPopupComponent } from '../sql-editor-popup/sql-editor-popup.component';
// import 'codemirror/addon/hint/show-hint.css';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { FieldMappingService } from 'src/app/shared/services/field-mapping.service';

export interface attributesEditData {
  editData: any;
  mappingConfigurationData:any;
  stageObjectList:any;
  codeListData:any;
  SourceId:any;
  targetId:any;
  allObjectsData:any;
  codeListNamesDistinctData:any;
  isViewMode?: boolean;
}
@Component({
    selector: 'app-attribute-mapping-popup',
    templateUrl: './attribute-mapping-popup.component.html',
    styleUrls: ['./attribute-mapping-popup.component.scss'],
    standalone: false
})
export class AttributeMappingPopupComponent implements OnInit {
 @ViewChild('codeEditor') codeEditor!: ElementRef;
  @ViewChild('codeExceptionEditor') codeExceptionEditor!: ElementRef;
  @ViewChild('freetextEditor') freetextEditor!: ElementRef;
  expressionDetails: string = '';
  freetextDetails : string = '';
  exceptionExpressionDetails: string = '';

  validations_form: UntypedFormGroup;
  mappingConfigurationData:any=[];
  selectedStageObject=[];
  sourceGrid;
  targetGrid;
  selectedObjects;
  validation_messages;
  selectedSourceAttributeList=[];
  selectedTargetAttribute;
  sourceAttributesDataList:any=[]
  targetAttributesDataList:any=[];
  mappingType;
  codelistValueType;
  codelistValueTypeQuery;
   codelistValueTypeConstant;
  selectedStageObjectForMappingType;
   selectedStageObjectAttributeForMappingType=null
   selectedStageObjectDetails
   query;
   codelistName;
  SourceId
  stageObjectList:any=[]
  selectedStageObjectAttributesList:any=[];
  selectedTargetAttributeList:any=[];
  selectedSourceAttributeListNames;
  mappingTypeDataDropDown:any = [];
  defult:any = [];
  buttonColor;
  backgroundColorScreen;

  isViewMode: boolean = false;
  mappingTypeData=[
    {
      label:"Direct Mapping",
      name:"Direct Mapping"
    },
    {
      label:"No Mapping",
      name:"No Mapping"
    },
    {
      label:"Functional Mapping",
      name:"Functional Mapping"
    },
    {
      label:"Codelist Mapping",
      name:"Codelist Mapping"
    },
    {
      label:"Lookup Mapping",
      name:"Lookup Mapping"
    },
    {
      label:"Concat Mapping",
      name:"Concat Mapping"
    }
  ]
   allocateButtonsBoolean = false;
  allocateButtons1Boolean=true;
  mappingAttributesId;
  mappingAttributeDTO;
  editData;
  fieldOrderId;
  codeListData;
  selectedReferenceSourceObjectsListNames
  selectedReferenceTargetObjectsListNames;
  selectedReferenceLibraryObjectsListNames;
  selectedReferenceGlobalObjectsListNames;
  selectedReferenceGlobalSourceObjectsListNames;
  selectedGlobalExternalObjectsListNames;
  selectedRefDBObjectNameListNames;
  selectedRefDBObjectNameFetchPartialsListNames;
  selectedReferenceValueMapping=[];
  selectedReferenceSourceObjectsList=[]
  selectedReferenceTargetObjectsList=[];
  selectedReferenceLibraryObjectsList=[];
  selectedReferenceGlobalObjectsList=[];
  selectedReferenceGlobalSourceObjectsList=[];
  selectedGlobalExternalObjectsList=[];
  selectedRefDBObjectNameFetchPartialsList=[];
  selectedRefDBObjectNameList=[]
  referenceExternalObjectsList
  targetdnsid;
  referenceSourceObjectsList;
  referenceTargetObjectsList;
  referenceLibraryObjectsLookupValue;
  referenceGlobalObjectsLookupValue;
  referenceSourceGlobalObjectsList;
  referenceLibraryObjectsList;
  referenceGlobalObjectsList;
  lookupMultiList=[];
  componentsLookup;
  gridApi;
  lookupColumnDefs;
  lookupButtonName="Save";
  lookUpIndex;
  valueMappingHeaders=[]
  codeListNamesDistinctData=[];
  selectedObjectMappingOrdeId
  constructor(
    private localStorageSettings: LocalStorageSettingsService,
        private constants: constants,private commonService:CommonService,
        private spinner: NgxUiLoaderService,private snackbar: MatSnackBar,
        private service: ReportingServiceService,
        private mappingAttributeServices:AttributeMappingConfigService,
        private msg: ErrorMessages,
        private validation: validationmethod,
        public dialogref: MatDialogRef<AttributeMappingPopupComponent>,
        private dialog: MatDialog,
        private linkservice: ReportlinksserviceService ,
        private etlservice:EtlService,
        @Inject(MAT_DIALOG_DATA) public data:attributesEditData,
        private valueMappingservice:FieldMappingService
  ) { 
    this.validation_messages = this.msg.mappingAttributes;
    this.componentsLookup= {
          buttonRenderer: Actionbutton
        }
  }

  ngOnInit(): void {
    this.formValidation();
    if (this.data?.isViewMode) {
    this.isViewMode = true;
  }
  if (this.isViewMode) {
  this.validations_form.disable();  
}
    this.editData=this.data.editData;
    console.log(this.editData);
    console.log(this.data)
    console.log(this.data.stageObjectList)
    this.SourceId=this.data.SourceId;
    this.targetdnsid=this.data.targetId
    this.mappingConfigurationData=this.data.mappingConfigurationData
    this.stageObjectList=this.data.allObjectsData
    console.log(this.stageObjectList);
    this.codeListData=this.data.codeListData
    this.codeListNamesDistinctData=this.data.codeListNamesDistinctData
        this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
     this.commonService.getlookupVauleByLookUpType("Mapping Type").subscribe(result => {
      console.log(result);
      this.mappingTypeDataDropDown = result;
      console.log(this.mappingTypeDataDropDown)

    });
    this.commonService.getlookupVauleByLookUpType("codelistValueType").subscribe(result => {
      console.log(result);
      this.defult = result;
      console.log(this.defult)

    });
    this.lookupColumnDefs = [{
      headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
       checkboxSelection: false,
      pinned:'left',
      lockPinned:true,
      cellRendererParams: {
        edit: this.EditLookupIcon.bind(this),
        delete: this.deleteLookUpIcon.bind(this),
      }, width: 150
    },
      { headerName: 'Selected Objects', headerTooltip: 'Selected Objects', tooltipValueGetter: (params) => 'Selected Objects : ' + params.value, field: 'selectedStageObjectForMappingType', filter: 'agTextColumnFilter'},
      { headerName: 'Selected Attributes', headerTooltip: 'Selected Attributes', tooltipValueGetter: (params) => 'Selected Attributes : ' + params.value, field: 'selectedStageObjectAttributeForMappingType', filter: 'agTextColumnFilter'},
      { headerName: 'Query', headerTooltip: 'Query', tooltipValueGetter: (params) => 'Query : ' + params.value, field: 'query', filter: 'agTextColumnFilter'},
    ]
  }

  ngAfterViewInit(){
     setTimeout(() => {
     setTimeout(() =>{
        this.EditIcon(this.editData)
       } , 100);
       }, 0);
  }
   formValidation() {
       this.validations_form = new UntypedFormGroup({
         objects: new UntypedFormControl("", [Validators.required]),
         expressionDetails:new UntypedFormControl(""),
         selectedSourceAttributeForExpression:new UntypedFormControl(""),
         selectedFunction:new UntypedFormControl(""),
         groupByFunction:new UntypedFormControl(""),
         conditionalValue:new UntypedFormControl(""),
         mappingType: new UntypedFormControl("", [Validators.required]),
         codelistname:new UntypedFormControl(""),
         selectStageSourceObjectsForm:new UntypedFormControl(""),
         selectTargetAttributeForm:new UntypedFormControl(""),
         selectStageObjectsForm:new UntypedFormControl(""),
         selectStageObjectsAttributesForm:new UntypedFormControl(""),
         codelistValueType:new UntypedFormControl(""),
          codelistValueTypeQuery:new UntypedFormControl(""),
          codelistValueTypeConstant:new UntypedFormControl(""),
         query:new UntypedFormControl(""),
           selectedReferenceSourceObjectsListNamesForm:new UntypedFormControl(""),
       selectedReferenceTargetObjectsListNamesForm:new UntypedFormControl(""), 
       selectedReferenceValueMappingForm:new UntypedFormControl(""), 
       selectedReferenceLibraryForm:new UntypedFormControl(""), 
       selectedReferenceGlobalObjectsListNamesForm:new UntypedFormControl(""), 
       selectedReferenceGlobalSourceObjectsListNamesForm:new UntypedFormControl(""),
       selectedGlobalExternalObjectsListNamesForm:new UntypedFormControl(""), 
        selectedRefDBObjectNameListNamesForm:new UntypedFormControl(""),
       selectedRefDBObjectNameFetchPartialsListNamesForm:new UntypedFormControl(""),
        //  fieldOrderId: new UntypedFormControl("", [Validators.required]),
        });
     }
 async onObjectSelectionChange(event){
    if(event.value != undefined){
    this.spinner.start();
    this.onObjectSelectionClearValues();
    console.log(event);
    let selectedMappingObject = await this.mappingConfigurationData.filter(item=>item.mappingconfigurationid == event.value)[0];
    console.log(selectedMappingObject);
    // stageobjectid targetobjectid
    this.selectedStageObject=[]
    let stageObject={
      objectName:selectedMappingObject.stageobject,
      objectId:selectedMappingObject.stageobjectid
    }
    this.selectedStageObject.push(stageObject)
    this.retriveAttributesBasedOnTheMappingConfigId(selectedMappingObject,[],[]);
    
    this.spinner.stop();
    }
  }

  retriveAttributesBasedOnTheMappingConfigId(selectedMappingObject,stageAttributesList,targetAttributeEditData){
    this.service.retrieveTablesFieldsForDataset(selectedMappingObject.stageobjectid).subscribe(res => {
      console.log(res);
      // checking if response is true or not
      if (res.error === true) {
        this.snackbar.open(res.message, "OK", { duration: 5000 });
        
      } else {
        let jsonSourceData=JSON.parse(res[0].attributeNameAndFields);
        console.log(jsonSourceData);
        let sourceAttributesData;
        if(jsonSourceData.datasets != undefined){
          sourceAttributesData=jsonSourceData.datasets[0].columns
        }else{
          sourceAttributesData=jsonSourceData
        }
        try {
          console.log("***********************SOURCE");
          console.log(sourceAttributesData);
          for(let i=0;i<sourceAttributesData.length;i++){
            if(sourceAttributesData[i].alias){
              sourceAttributesData[i].label=sourceAttributesData[i].alias
            }
          }
          this.sourceAttributesDataList=sourceAttributesData
          console.log(this.sourceAttributesDataList);
          
          // if(stageAttributesList.length > 0){
          //   for(let i=0;i<stageAttributesList.length;i++){
          //     this.sourceGrid.api.forEachNode(node=>{
          //       // console.log(node.data.objectlabel+"============="+this.mappingCreationData.stageobject)
          //       if(node.data['name']===stageAttributesList[i].name && node.data['label']===stageAttributesList[i].label){
          //            node.setSelected(true)
          //       }
          //     })
          //   }
            
          // }
         
        } catch (error) {
          
          console.error('Error accessing user:', error);
        }
       
      }
    });
    this.service.retrieveTablesFieldsForDataset(selectedMappingObject.targetobjectid).subscribe(res => {
      console.log(res);
      // checking if response is true or not
      if (res.error === true) {
        this.snackbar.open(res.message, "OK", { duration: 5000 });
      } else {
        let jsonTargetData=JSON.parse(res[0].attributeNameAndFields);
        console.log(jsonTargetData);
        let targetAttributesData;
        if(jsonTargetData.datasets != undefined){
          targetAttributesData=jsonTargetData.datasets[0].columns
        }else{
          targetAttributesData=jsonTargetData
        }
        try {
          console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&TARGET");
          console.log(targetAttributesData);
          for(let i=0;i<targetAttributesData.length;i++){
            if(targetAttributesData[i].alias){
              targetAttributesData[i].label=targetAttributesData[i].alias
            }
          }
          this.targetAttributesDataList=targetAttributesData
          // if(targetAttributeEditData.length > 0){
          //     this.targetGrid.api.forEachNode(node=>{      
          //       for(let i=0;i<targetAttributeEditData.length;i++){
          //       // console.log(node.data.objectlabel+"============="+this.mappingCreationData.stageobject)
          //       if(node.data['name']===targetAttributeEditData[i].name && node.data['label']===targetAttributeEditData[i].label){
          //            node.setSelected(true)
          //       }
          //     }
          //     })
          // }
        } catch (error) {
          console.error('Error accessing user:', error);
        }
        
      }

    });
  }
  searchableStageSourceObjects(){
     if(this.sourceAttributesDataList.length > 0){
            var columndata = []
          var c = {
            "label": "Attribute Label",
            "name":"Attribute Name"
          } 
         columndata.push(c)
         
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:this.sourceAttributesDataList,
              page:"multiple",
              columns:columndata,
              selectedValue:this.selectedSourceAttributeList,
              selectedPropertyName:"name"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            this.selectedSourceAttributeList=result.selectedRows
            console.log(this.selectedSourceAttributeList);
            
           this.selectedSourceAttributeListNames = this.selectedSourceAttributeList
                                                      .map(item => item.name)
                                                      .join(',');
          }
          })
        }
  }

  searchableTargetObjects(){
     if(this.targetAttributesDataList.length > 0){
            var columndata = []
          var c = {
            "label": "Attribute Label",
            "name":"Attribute Name"
          } 
         columndata.push(c)
         
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:this.targetAttributesDataList,
              page:"single",
              columns:columndata,
              selectedValue:[this.selectedTargetAttribute],
              selectedPropertyName:"name"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            this.selectedTargetAttribute=result.selectedRows[0].name
            this.selectedTargetAttributeList=result.selectedRows
          }
          })
        }
  }
  async EditIcon(rowData){
    console.log(rowData);
    // this.buttonName="Update Map"
    this.selectedObjects=rowData.mappingObjectId
    this.mappingAttributesId=rowData.mappingAttributesId
    let orderId = this.mappingConfigurationData.find(item => item.mappingconfigurationid ===  this.selectedObjects)?.orderId ?? null;

    this.selectedObjectMappingOrdeId=orderId;
    this.mappingType=rowData.mapping_type
    if (rowData.codelist_value_type && rowData.codelist_value_type.includes('Query:')) {
      console.log("****************************");
      
      const queryPart = rowData.codelist_value_type.split('Query:')[1].trim();
      this.codelistValueType="Query"
      this.codelistValueTypeQuery=queryPart;
      this.codelistValueTypeConstant=""
    } else {
      if(rowData.codelist_value_type == "Source" || rowData.codelist_value_type == "Null"){
         this.codelistValueType=rowData.codelist_value_type;
          this.codelistValueTypeQuery="";
      this.codelistValueTypeConstant=""
      }else{
        this.codelistValueType="Constant"
      this.codelistValueTypeConstant=rowData.codelist_value_type
      }
      console.log('No Query: prefix found.');
    }
    this.selectedReferenceSourceObjectsListNames=rowData.reference_source
    this.selectedReferenceTargetObjectsListNames=rowData.reference_target
this.selectedReferenceLibraryObjectsListNames=rowData.reference_vault_object
  this.selectedReferenceGlobalObjectsListNames=rowData.reference_global_object
  this.selectedReferenceGlobalSourceObjectsListNames=rowData.reference_global_source_library
  this.selectedGlobalExternalObjectsListNames=rowData.global_external_object
  this.selectedRefDBObjectNameFetchPartialsListNames=rowData.reference_Database_Object_Fetch_Partial
   this.selectedRefDBObjectNameListNames=rowData.reference_Database_Object_Name
    if(rowData.reference_library){
      this.selectedReferenceValueMapping=rowData.reference_library.split(',');
    }
   
    if(this.selectedReferenceSourceObjectsListNames){
this.selectedReferenceSourceObjectsList=this.selectedReferenceSourceObjectsListNames.split(',');
    }else{
      this.selectedReferenceSourceObjectsList=[]
    }
    if(this.selectedReferenceTargetObjectsListNames){
     this.selectedReferenceTargetObjectsList=this.selectedReferenceTargetObjectsListNames.split(',');
    }else{
      this.selectedReferenceTargetObjectsList=[]
    }



     if(this.selectedReferenceLibraryObjectsListNames){
     this.selectedReferenceLibraryObjectsList=this.selectedReferenceLibraryObjectsListNames.split(',');
    }else{
      this.selectedReferenceLibraryObjectsList=[]
    }
    
     if(this.selectedReferenceGlobalObjectsListNames){
     this.selectedReferenceGlobalObjectsList=this.selectedReferenceGlobalObjectsListNames.split(',');
    }else{
      this.selectedReferenceGlobalObjectsList=[]
    }

     if(this.selectedReferenceGlobalSourceObjectsListNames){
     this.selectedReferenceGlobalSourceObjectsList=this.selectedReferenceGlobalSourceObjectsListNames.split(',');
    }else{
      this.selectedReferenceGlobalSourceObjectsList=[]
    }

    if(this.selectedGlobalExternalObjectsListNames){
     this.selectedGlobalExternalObjectsList=this.selectedGlobalExternalObjectsListNames.split(',');
    }else{
      this.selectedGlobalExternalObjectsList=[]
    }

     if(this.selectedRefDBObjectNameFetchPartialsListNames){
     this.selectedRefDBObjectNameFetchPartialsList=this.selectedRefDBObjectNameFetchPartialsListNames.split(',');
    }else{
      this.selectedRefDBObjectNameFetchPartialsList=[]
    }

    if(this.selectedRefDBObjectNameListNames){
     this.selectedRefDBObjectNameList=this.selectedRefDBObjectNameListNames.split(',');
    }else{
      this.selectedRefDBObjectNameList=[]
    }

    
    // this.codelistValueType=rowData.codelist_value_type
    this.spinner.start();
    console.log();
    let stageAttributesList = JSON.parse(rowData.source_attribute)
    let targetAttributeList = JSON.parse(rowData.target_attribute_list)

     this.selectedSourceAttributeList=stageAttributesList;
            console.log(this.selectedSourceAttributeList);
     this.selectedSourceAttributeListNames = this.selectedSourceAttributeList.map(item => item.name).join(',');

     this.selectedTargetAttribute=rowData.target_attribute
     this.selectedTargetAttributeList=targetAttributeList
    this.mappingAttributeDTO=rowData
    // this.selectedSourceAttributeList=stageAttributesList
    let selectedMappingObject = await this.mappingConfigurationData.filter(item=>item.mappingconfigurationid == rowData.mappingObjectId)[0];
    console.log(selectedMappingObject);
   this.codelistName=rowData.codelistname
    // stageobjectid targetobjectid
    this.retriveAttributesBasedOnTheMappingConfigId(selectedMappingObject,stageAttributesList,targetAttributeList);
    this.expressionDetails=rowData.mapping_logic
      if(this.mappingType == 'Lookup Mapping'){
        if(this.expressionDetails){
          let list= this.expressionDetails.split(';Lookup:');
          console.log(list);
          
          for(let i=0;i<list.length;i++){
            let parts = list[i].split(',');
            let item ={
              index:i,
              selectedStageObjectForMappingType:parts[0],
              selectedStageObjectAttributeForMappingType:parts[1],
              query:parts.slice(2).join(',')
            }
            this.lookupMultiList.push(item);
          }
          const lookupMap: Record<string, string[]> = {};
          if (this.mappingAttributeDTO.lookupMappingDetails) {
            this.mappingAttributeDTO.lookupMappingDetails.split(";").forEach(pair => {
              const [key, value] = pair.split(":");
              if (!lookupMap[key]) {
                lookupMap[key] = [];
              }
              lookupMap[key].push(value); // store all values for each key
            });
          }
            // Step 2: Use counters per key to assign dnsType in order
            const keyCounters: Record<string, number> = {};
            if(this.lookupMultiList.length > 0){
            this.lookupMultiList = this.lookupMultiList.map(obj => {
              const key = obj.selectedStageObjectForMappingType;
              const values = lookupMap[key];

              if (values && values.length > 0) {
                const index = keyCounters[key] || 0;
                obj.dnsType = values[index] || null; // in case more objects than values
                keyCounters[key] = index + 1;
              } else {
                obj.dnsType = null; // fallback if not found
              }

              return obj;
            });
          }
          // this.selectedStageObjectForMappingType = 
          // this.selectedStageObjectAttributeForMappingType= parts[1];  
          // this.query= parts.slice(2).join(','); 
      //      const stageObject=this.stageObjectList.filter(item=>item.objectname ==  this.selectedStageObjectForMappingType);
      //      console.log(stageObject);
           
      //      const attributesJson= stageObject[0].objectattributes ? JSON.stringify(JSON.parse(stageObject[0].objectattributes), null, 2):"";
      //   const columns=JSON.parse(attributesJson)
      //   // this.selectedStageObjectAttributesList=columns.datasets[0].columns;
      //  if(columns.datasets){
      //     this.selectedStageObjectAttributesList=columns.datasets[0].columns;
      //   }else{
      //     this.selectedStageObjectAttributesList=columns;
      //   }
        console.log(this.selectedStageObjectAttributesList);
        
        }
    }else if(this.mappingType == 'Concat Mapping'){
       if(this.expressionDetails){
          this.query=this.expressionDetails
       }
    }

   if(this.mappingType == 'Functional Mapping'){
      this.getSourceReferenceObjects()
    }

    this.exceptionExpressionDetails=rowData.exceptionquery
    
    if(rowData.bussinesslogic){
      this.freetextDetails = rowData.bussinesslogic
    }else{
      this.freetextDetails = ""
    }
    // this.freeEditor.setValue(this.freetextDetails);
    console.log(this.mappingAttributeDTO);
    console.log(this.selectedSourceAttributeList);
    
    this.spinner.stop();
   }

  onMappingTypeChange(event){
if(event.value == "Codelist Mapping"){
  this.validations_form.controls["codelistname"].setValidators([Validators.required]);
  this.validations_form.controls["codelistname"].updateValueAndValidity();
  this.validations_form.controls["selectStageObjectsForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsForm"].updateValueAndValidity()
  this.validations_form.controls["selectStageObjectsAttributesForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsAttributesForm"].updateValueAndValidity()
  this.validations_form.controls["query"].clearValidators();
  this.validations_form.controls["query"].updateValueAndValidity()
}else if(event.value == 'Lookup Mapping' ){
   this.validations_form.controls["selectStageObjectsForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsForm"].updateValueAndValidity()
  this.validations_form.controls["selectStageObjectsAttributesForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsAttributesForm"].updateValueAndValidity()
    this.validations_form.controls["query"].clearValidators();
  this.validations_form.controls["query"].updateValueAndValidity();
   this.validations_form.controls["codelistValueType"].setValidators([Validators.required]);
  this.validations_form.controls["codelistValueType"].updateValueAndValidity();
}else if(event.value == 'Concat Mapping' ){
 this.validations_form.controls["codelistname"].clearValidators();
  this.validations_form.controls["codelistname"].updateValueAndValidity();
  this.validations_form.controls["selectStageObjectsForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsForm"].updateValueAndValidity()
  this.validations_form.controls["selectStageObjectsAttributesForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsAttributesForm"].updateValueAndValidity()
  this.validations_form.controls["query"].setValidators([Validators.required]);
  this.validations_form.controls["query"].updateValueAndValidity()
}else{
  this.validations_form.controls["codelistname"].clearValidators();
  this.validations_form.controls["codelistname"].updateValueAndValidity();
  this.validations_form.controls["selectStageObjectsForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsForm"].updateValueAndValidity()
  this.validations_form.controls["selectStageObjectsAttributesForm"].clearValidators();
  this.validations_form.controls["selectStageObjectsAttributesForm"].updateValueAndValidity()
    this.validations_form.controls["query"].clearValidators();
  this.validations_form.controls["query"].updateValueAndValidity()
}
if(event.value == 'Functional Mapping'){
  this.getSourceReferenceObjects()
}
}
onCodelistDefalutValueTypeChange(){
 if(this.codelistValueType == "Query"){
    this.validations_form.controls["codelistValueTypeQuery"].setValidators([Validators.required]);
    this.validations_form.controls["codelistValueTypeQuery"].updateValueAndValidity();
    this.validations_form.controls["codelistValueTypeConstant"].clearValidators();
    this.validations_form.controls["codelistValueTypeConstant"].updateValueAndValidity();
  }else if(this.codelistValueType == "Constant"){
    this.validations_form.controls["codelistValueTypeConstant"].setValidators([Validators.required]);
    this.validations_form.controls["codelistValueTypeConstant"].updateValueAndValidity();
    this.validations_form.controls["codelistValueTypeQuery"].clearValidators();
    this.validations_form.controls["codelistValueTypeQuery"].updateValueAndValidity();
  }else{
    this.validations_form.controls["codelistValueTypeQuery"].clearValidators();
    this.validations_form.controls["codelistValueTypeQuery"].updateValueAndValidity();
    this.validations_form.controls["codelistValueTypeConstant"].clearValidators();
    this.validations_form.controls["codelistValueTypeConstant"].updateValueAndValidity();
  }
}

createTransformationQuery(){
  console.log("********************************************TTTTT");
  // let transformQuery=this.selectedStageObjectForMappingType+","+this.selectedStageObjectAttributeForMappingType+","+this.query
  // console.log(transformQuery)
  let transformQuery = [
  this.selectedStageObjectForMappingType,
  this.selectedStageObjectAttributeForMappingType,
  this.query
]
.filter(value => value !== null && value !== undefined && value !== '')
.join(',');
console.log(transformQuery)
let transformedQuery;
for(let i=0;i<this.lookupMultiList.length;i++){
  if(i==0){
    transformedQuery=[
  this.lookupMultiList[i].selectedStageObjectForMappingType,
  this.lookupMultiList[i].selectedStageObjectAttributeForMappingType,
  this.lookupMultiList[i].query
]
.filter(value => value !== null && value !== undefined && value !== '')
.join(',');
  }else{
    let query=[
  this.lookupMultiList[i].selectedStageObjectForMappingType,
  this.lookupMultiList[i].selectedStageObjectAttributeForMappingType,
  this.lookupMultiList[i].query
]
.filter(value => value !== null && value !== undefined && value !== '')
.join(',');
    transformedQuery=transformedQuery+";Lookup:"+query;
  }
}
if(transformedQuery){
this.expressionDetails=transformedQuery
}else{
  this.expressionDetails=''
}
}

searchableObjects(){
  if(this.stageObjectList.length > 0){
        var columndata = []
     var c = {
        "objectlabel": "Object Label",
        "objectname":"Object Name",
        "dnsType":"Type",
        "status":"Status",
      } 
     columndata.push(c)
      let selectedObject;
     if(this.selectedStageObjectForMappingType){
      selectedObject={
      objectname:this.selectedStageObjectForMappingType,
      dnsType:this.selectedStageObjectDetails.dnsType
     }
     }else{
      selectedObject=this.selectedStageObjectForMappingType
     }
      let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
        width: "50%",
        autoFocus: false,
        disableClose: true,
        data: { 
          edata:this.stageObjectList,
          page:"single",
          columns:columndata,
          selectedValue:[selectedObject],
          selectedPropertyName:"objectname"
        }
      });
       dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != undefined) {
        if(result.selectedRows.length > 0){
        this.selectedStageObjectForMappingType=result.selectedRows[0].objectname;
        this.selectedStageObjectDetails=result.selectedRows[0];
        console.log(this.selectedStageObjectDetails);
        if(this.selectedStageObjectDetails.dnsType !="ValueMapping"){
          const objectAttributes = result.selectedRows[0].objectattributes ? JSON.parse(result.selectedRows[0].objectattributes) : {};
          const attributesJson= result.selectedRows[0].objectattributes ? JSON.stringify(JSON.parse(result.selectedRows[0].objectattributes), null, 2):"";
          const columns=JSON.parse(attributesJson)
          if(columns.datasets){
            this.selectedStageObjectAttributesList=columns.datasets[0].columns;
          }else{
            this.selectedStageObjectAttributesList=columns;
          }
          
          console.log(this.selectedStageObjectAttributesList);
          this.selectedStageObjectAttributeForMappingType=null
          //  this.createTransformationQuery()
        }else{
          this.spinner.start();
          this.valueMappingservice.retreiveFieldMapping(this.selectedStageObjectDetails.mappingTypeId).subscribe(response=>{
            if(response.error == true){
               this.spinner.stop();
            }else{
              let getdata:any=response
              let data:any = JSON.parse(getdata.mappedFieldsData)
              console.log(data);
              let headers=JSON.parse(getdata.mappedFields)
              if(headers){
                console.log(headers);
                this.valueMappingHeaders=[]
                this.valueMappingHeaders.push(...headers.SourceColumns)
                this.valueMappingHeaders.push(...headers.TargetColumns)
                // this.headersDataDetails=headers
                console.log(this.valueMappingHeaders);
                 this.selectedStageObjectAttributesList=this.valueMappingHeaders
              }
               this.spinner.stop();
            }
          })
        }
        }else{
           this.selectedStageObjectForMappingType=null;
           this.selectedStageObjectDetails=null;
            this.selectedStageObjectAttributeForMappingType=null
            this.selectedStageObjectAttributesList=[]
        }
      }
      })
    }
}

searchableAttributes(){
  if(!this.selectedStageObjectForMappingType){
    this.selectedStageObjectAttributesList=[]
  }
 if(this.selectedStageObjectAttributesList.length > 0){
        var columndata = []
       let selectedPropertyNameDetails;
       console.log(this.selectedStageObjectDetails);
       
     if(this.selectedStageObjectDetails.dnsType =="ValueMapping"){
      var headers={
        "label": "Label",
      }
       columndata.push(headers)
       selectedPropertyNameDetails="label"
     }else{
      var c = {
        "label": "Attribute Label",
        "name":"Attribute Name",
        "alias":"Attribute Alias",
      }
      columndata.push(c)
     selectedPropertyNameDetails="name"
    }
      let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
        width: "60%",
        autoFocus: false,
        disableClose: true,
        data: { 
          edata:this.selectedStageObjectAttributesList,
          page:"single",
          columns:columndata,
          selectedValue:[this.selectedStageObjectAttributeForMappingType],
          selectedPropertyName:selectedPropertyNameDetails
        }
      });
       dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != undefined) {
        if(result.selectedRows.length > 0){
          if(this.selectedStageObjectDetails.dnsType =="ValueMapping"){
            this.selectedStageObjectAttributeForMappingType=result.selectedRows[0].label;
          }else{
            this.selectedStageObjectAttributeForMappingType=result.selectedRows[0].name;
          }
           
          //  this.createTransformationQuery()
        }else{
           this.selectedStageObjectAttributeForMappingType=null;
        }
       
        
      }
      })
    }
}
 generateSQL() {
  const sqlText = this.freetextDetails ; // 👈 Get current content from CodeMirror
  console.log('Generated SQL:', sqlText);

  // Optional: Show in alert box with copyable prompt (copy using Ctrl+C)
  // alert('Generated SQL:\n\n' + sqlText);
  window.prompt("Generated SQL (press Ctrl+C to copy):", sqlText);
}

openSqlBuilderPopUpForTransformation(){
 let dialogRef = this.dialog.open(SqlEditorPopupComponent, { 
        width: "90%",
        autoFocus: false,
        maxWidth: '100vw',
        height: "95%",
        disableClose: true,
        data: { objectList: this.selectedStageObject },
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        this.expressionDetails = result;
      })  
}
openSqlBuilderPopUpForException(){
  let dialogRef = this.dialog.open(SqlEditorPopupComponent, { 
         width: "90%",
         autoFocus: false,
         maxWidth: '100vw',
         height: "95%",
         disableClose: true,
         data: { objectList: this.selectedStageObject },
       });
       dialogRef.afterClosed().subscribe(result => {
         console.log(result);
        //  this.editor.setValue(result);
         this.exceptionExpressionDetails = result;
       })  
 }
 closeFunction(){
     this.isViewMode = false; 
    this.dialogref.close(null)
  }

  async mapAttributes(){
    // Allow multiple source attributes only for Functional Mapping
if (
this.mappingType !== 'Functional Mapping' &&
this.selectedSourceAttributeList.length > 1
) {
this.snackbar.open(
'Multiple source/stage attributes are allowed only for Functional Mapping',
'OK',
{
duration: 5000,
}
);

return;

}
    console.log(this.lookupMultiList);
    
  if (!this.validations_form.valid) {

    // displaying validation messages
    this.validation.validateAllFormFields(this.validations_form);

    this.validation.getvalidationmessage();

  } else {
    console.log(this.selectedSourceAttributeList);
    console.log(this.selectedTargetAttribute);
    console.log(this.selectedTargetAttributeList);
     if(this.mappingType == "Direct Mapping"){
      if(this.selectedSourceAttributeList.length == 0 && this.selectedTargetAttributeList.length == 0){
            this.snackbar.open("Please select atleast one source or one target attribute", "OK", {
          duration: 5000,});
          return;
      }
    }

    if(this.mappingType == "No Mapping" || this.mappingType == "Concat Mapping" || this.mappingType == "Codelist Mapping" || this.mappingType == "Lookup Mapping"){
      if(this.selectedSourceAttributeList.length == 0){
            this.snackbar.open("Please select atleast one source attribute", "OK", {
          duration: 5000,});
          return;
      }
    }

     if(this.mappingType == "Functional Mapping" || this.mappingType == "Concat Mapping" || this.mappingType == "Codelist Mapping" || this.mappingType == "Lookup Mapping"){
      if(this.selectedTargetAttributeList.length == 0){
            this.snackbar.open("Please select atleast one target attribute", "OK", {
          duration: 5000,});
          return;
      }
    }
    
     if(this.mappingType == "Lookup Mapping"){
      if(this.expressionDetails.length == 0){
            this.snackbar.open("Please add atleast one Object,Attribute,Query details", "OK", {
          duration: 5000,});
          return;
      }
    }
    // if(this.selectedSourceAttributeList.length > 0 && this.selectedTargetAttributeList.length>0){
      if(this.mappingType == "Functional Mapping" && this.expressionDetails.length == 0){
          this.snackbar.open("Please Enter the transformation query", "OK", {
                duration: 5000,
              });
      }else{
    this.spinner.start();
    this.mappingAttributeDTO.source_attribute=this.selectedSourceAttributeList;
    this.mappingAttributeDTO.target_attribute=this.selectedTargetAttribute;
    this.mappingAttributeDTO.target_attribute_list=this.selectedTargetAttributeList
    this.mappingAttributeDTO.mapping_type=this.mappingType
    this.mappingAttributeDTO.mapping_logic=this.expressionDetails;
    this.mappingAttributeDTO.exceptionquery=this.exceptionExpressionDetails
    this.mappingAttributeDTO.mappingObjectId=this.selectedObjects
    this.mappingAttributeDTO.bussinesslogic = this.freetextDetails
    let selectedMappingObject = await this.mappingConfigurationData.filter(item=>item.mappingconfigurationid == this.selectedObjects)[0];
    console.log(selectedMappingObject);
    this.mappingAttributeDTO.source_object=selectedMappingObject.stageobject
    this.mappingAttributeDTO.source_object_id=selectedMappingObject.stageobjectid
    this.mappingAttributeDTO.target_object=selectedMappingObject.targetobject
    this.mappingAttributeDTO.target_object_id=selectedMappingObject.targetobjectid
    this.mappingAttributeDTO.codelistname=this.codelistName
    this.mappingAttributeDTO.fieldorderid=this.fieldOrderId;
    if(this.codelistValueType == "Query"){
      this.mappingAttributeDTO.codelist_value_type="Query:"+this.codelistValueTypeQuery
    }else if(this.codelistValueType == "Constant"){
      this.mappingAttributeDTO.codelist_value_type=this.codelistValueTypeConstant
    }else{
       this.mappingAttributeDTO.codelist_value_type=this.codelistValueType
    }
    this.mappingAttributeDTO.reference_source=this.selectedReferenceSourceObjectsListNames;
   this.mappingAttributeDTO.reference_target=this.selectedReferenceTargetObjectsListNames;
    if(this.selectedReferenceValueMapping){
   this.mappingAttributeDTO.reference_library=this.selectedReferenceValueMapping.join(',');
   }else{
    this.mappingAttributeDTO.reference_library=""
   }
   this.mappingAttributeDTO.reference_vault_object=this.selectedReferenceLibraryObjectsListNames;
     this.mappingAttributeDTO.reference_global_object=this.selectedReferenceGlobalObjectsListNames
     this.mappingAttributeDTO.reference_global_source_library=this.selectedReferenceGlobalSourceObjectsListNames;
     this.mappingAttributeDTO.global_external_object=this.selectedGlobalExternalObjectsListNames;
      this.mappingAttributeDTO.reference_Database_Object_Name=this.selectedRefDBObjectNameListNames;
     this.mappingAttributeDTO.reference_Database_Object_Fetch_Partial=this.selectedRefDBObjectNameFetchPartialsListNames;
    let dnsId = this.localStorageSettings.getSettings("dnsName");
    this.mappingAttributeDTO.tenantId=dnsId
    if(this.mappingType == 'Lookup Mapping' && this.lookupMultiList.length > 0){ 
        console.log(this.lookupMultiList);
        const resultString = this.lookupMultiList
        .map(obj => `${obj.selectedStageObjectForMappingType}:${obj.dnsType}`)
        .join(';');
         this.mappingAttributeDTO.lookupMappingDetails=resultString;
    }else{
      this.mappingAttributeDTO.lookupMappingDetails=""
    }

   
    console.log(this.mappingAttributeDTO);
    
    this.mappingAttributeServices.createMappingAttributes(this.mappingAttributeDTO,this.mappingAttributesId).subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
      }else{
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.spinner.stop();
        this.dialogref.close("Refresh")
      }
    })
  }
  // }else{
  //   this.snackbar.open("Please select atleast one source attribute and target attribute", "OK", {
  //     duration: 5000,
  //   });
  // }
  }
  }
searchableReferenceSourceObjects(){
     if(this.referenceSourceObjectsList.length > 0){
            var columndata = []
          var c = {
            "objectlabel": "Object Label",
            "objectname":"Object Name"
          } 
         columndata.push(c)
         let selectedList=[];
         if(this.selectedReferenceSourceObjectsList.length >0){
            selectedList = this.selectedReferenceSourceObjectsList
         }
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:this.referenceSourceObjectsList,
              page:"multiple",
              columns:columndata,
              selectedValue:selectedList,
              selectedPropertyName:"objectname"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            console.log(result.selectedRows);
            this.selectedReferenceSourceObjectsList=result.selectedRows.map((item: any) => item.objectname);
           this.selectedReferenceSourceObjectsListNames = result.selectedRows.map(item => item.objectname).join(',');
          }
          })
        }
  }
 searchableReferenceTargetObjects(){
     if(this.mappingConfigurationData.length > 0){
       let filteredObjectMappingBasedOnOrderIdList = this.mappingConfigurationData.filter(item =>
      item.orderId !== null && item.orderId < this.selectedObjectMappingOrdeId
    ).sort((a, b) => a.orderId - b.orderId);
            var columndata = []
          var c = {
            "orderId":"Order Id",
             "combined": "Reference Transform",
          } 
         columndata.push(c)
         let selectedList=[]
         if(this.selectedReferenceTargetObjectsList.length > 0){
          for(let i=0;i<this.selectedReferenceTargetObjectsList.length;i++){
            let subObjects=this.selectedReferenceTargetObjectsList[i].split("--")
            let objects={
              "stageobject":subObjects[0],
              "targetobject":subObjects[1]
            }
             selectedList.push(objects)
          }
         
         }
         console.log(selectedList);
         
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:filteredObjectMappingBasedOnOrderIdList,
              page:"multiple",
              columns:columndata,
              selectedValue:selectedList,
              selectedPropertyName:"stageobject"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            console.log(result.selectedRows);
            this.selectedReferenceTargetObjectsList=result.selectedRows.map((item: any) => item.stageobject+"--"+item.targetobject)
           this.selectedReferenceTargetObjectsListNames = result.selectedRows.map(item => item.stageobject+"--"+item.targetobject).join(',');
             console.log();
                                                      
          }
          })
        }
  }
  searchableReferenceLibraryObjects(){
     if(this.referenceLibraryObjectsList.length > 0){
            var columndata = []
          var c = {
             "objectlabel": "Object Label",
            "objectname":"Object Name"
          } 
         columndata.push(c)
         let selectedList=[]
         if(this.selectedReferenceLibraryObjectsList.length > 0){
          selectedList=this.selectedReferenceLibraryObjectsList;
         }
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:this.referenceLibraryObjectsList,
              page:"multiple",
              columns:columndata,
              selectedValue:selectedList,
              selectedPropertyName:"objectname"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            console.log(result.selectedRows);
            this.selectedReferenceLibraryObjectsList=result.selectedRows.map((item: any) => item.objectname)
           this.selectedReferenceLibraryObjectsListNames = result.selectedRows.map(item => item.objectname).join(',');
             console.log();
                                                      
          }
          })
        }
  }
  searchableReferenceGlobalObjects(){
     if(this.referenceGlobalObjectsList.length > 0){
            var columndata = []
          var c = {
            "objectlabel": "Object Label",
            "objectname":"Object Name"
          } 
         columndata.push(c)
         let selectedList=[];
         if(this.selectedReferenceGlobalObjectsList.length >0){
            selectedList = this.selectedReferenceGlobalObjectsList;
         }
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:this.referenceGlobalObjectsList,
              page:"multiple",
              columns:columndata,
              selectedValue:selectedList,
              selectedPropertyName:"objectname"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            console.log(result.selectedRows);
            this.selectedReferenceGlobalObjectsList=result.selectedRows.map((item: any) => item.objectname);
           this.selectedReferenceGlobalObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
          }
          })
        }
  }

  searchableReferenceGlobalSourceObjects(){
     if(this.referenceSourceGlobalObjectsList.length > 0){
            var columndata = []
          var c = {
            "objectlabel": "Object Label",
            "objectname":"Object Name"
          } 
         columndata.push(c)
         let selectedList=[];
         if(this.selectedReferenceGlobalSourceObjectsList.length >0){
            selectedList = this.selectedReferenceGlobalSourceObjectsList;
         }
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:this.referenceSourceGlobalObjectsList,
              page:"multiple",
              columns:columndata,
              selectedValue:selectedList,
              selectedPropertyName:"objectname"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            console.log(result.selectedRows);
            this.selectedReferenceGlobalSourceObjectsList=result.selectedRows.map((item: any) => item.objectname);
           this.selectedReferenceGlobalSourceObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
          }
          })
        }
  }
  searchableGlobalExternalObjects(){
     if(this.referenceExternalObjectsList.length > 0){
            var columndata = []
          var c = {
            "objectlabel": "Object Label",
            "objectname":"Object Name"
          } 
         columndata.push(c)
         let selectedList=[];
         if(this.selectedGlobalExternalObjectsList.length >0){
            selectedList = this.selectedGlobalExternalObjectsList;
         }
          let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
            width: "50%",
            autoFocus: false,
            disableClose: true,
            data: { 
              edata:this.referenceExternalObjectsList,
              page:"multiple",
              columns:columndata,
              selectedValue:selectedList,
              selectedPropertyName:"objectname"
            }
          });
           dialogRef.afterClosed().subscribe(result => {
          console.log(result);
          if (result != undefined) {
            console.log(result.selectedRows);
            this.selectedGlobalExternalObjectsList=result.selectedRows.map((item: any) => item.objectname);
           this.selectedGlobalExternalObjectsListNames =result.selectedRows.map(item => item.objectname).join(',');
          }
          })
        }
  }
getSourceReferenceObjects(){
     this.spinner.start();
      this.commonService.retrieveObjectGroupObjectsbasedDns(this.SourceId).subscribe(res=>{
            if (res.error === true) {
                // this.ObjectGrid.api.setGridOption('rowData', []);
            } else {
               
                console.log(res);
                const objects = res.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
               
                this.referenceSourceObjectsList = objects;
                 this.commonService.getlookupVauleByLookUpType("Vault Object Group").subscribe(result => {
                  console.log(result);
                  // this.mappingTypeDataDropDown = result;
                  // console.log(this.mappingTypeDataDropDown)
                 let lookupDetails:any=result
                  let ExternalLookupValue=lookupDetails.filter(item=>item.lookupcode=="External")
                  this.referenceLibraryObjectsLookupValue=lookupDetails.filter(item=>item.lookupcode=="Library");
                  this.referenceGlobalObjectsLookupValue=lookupDetails.filter(item=>item.lookupcode=="Global");
                  console.log(ExternalLookupValue);
                  let lookupValueId=ExternalLookupValue[0].lookupvalueid
                  const externalObjects = res.filter(item=>item.objecttype == lookupValueId);
                  console.log(externalObjects);
                  console.log("*****************************");
                  
                   this.referenceExternalObjectsList=externalObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                let globalLookupId=this.referenceGlobalObjectsLookupValue[0].lookupvalueid
                const globalObjects=res.filter(item=>item.objecttype == globalLookupId);
                this.referenceSourceGlobalObjectsList=globalObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                 })
                this.getTargetReferenceObjects();
            }
            
    })
  }
 getTargetReferenceObjects(){

        this.commonService.retrieveNonStageObjectsbasedDns(this.targetdnsid).subscribe(res=>{
            if (res.error === true) {
                // this.ObjectGrid.api.setGridOption('rowData', []);
                 this.spinner.stop();
            } else {
              
                console.log(res);
                const objects = res.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                  this.referenceTargetObjectsList = objects;
                  let lookupValueId=this.referenceLibraryObjectsLookupValue[0].lookupvalueid
                  const LibraryObjects = res.filter(item=>item.objecttype == lookupValueId);
                  
                   this.referenceLibraryObjectsList=LibraryObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                console.log(this.referenceLibraryObjectsList);

                 let globalLookupValueId=this.referenceGlobalObjectsLookupValue[0].lookupvalueid
                  const GlobalObjects = res.filter(item=>item.objecttype == globalLookupValueId);
                  
                   this.referenceGlobalObjectsList=GlobalObjects.map((item: any, index: number) => ({
                    id: item.id || index, // Assign index if id is missing
                    objectlabel: item.objectlabel || item,
                    objectname: item.objectname || ""
                }));
                   this.spinner.stop();
            }
            
    });
  }
  createTransformationQueryConcat(){
      console.log("********************************************TTTTT");
      // let transformQuery=this.selectedStageObjectForMappingType+","+this.selectedStageObjectAttributeForMappingType+","+this.query
      // console.log(transformQuery)
      let transformQuery = [
      this.selectedStageObjectForMappingType,
      this.selectedStageObjectAttributeForMappingType,
      this.query
    ]
    .filter(value => value !== null && value !== undefined && value !== '')
    .join(',');
    console.log(transformQuery)
    this.expressionDetails=transformQuery
}
  addWhere(){
    if(!this.selectedStageObjectForMappingType || this.selectedStageObjectForMappingType.trim().length ==0){
      this.snackbar.open("Please add Object", "OK", {
          duration: 5000,
        });
        return;
    }

    if(!this.selectedStageObjectAttributeForMappingType || this.selectedStageObjectAttributeForMappingType.trim().length ==0){
      this.snackbar.open("Please add Attribute", "OK", {
          duration: 5000,
        });
        return;
    }
    if(!this.query || this.query.trim().length ==0){
      this.snackbar.open("Please add Query", "OK", {
          duration: 5000,
        });
        return;
    }
    if(this.lookupButtonName=="Update"){
      this.lookupMultiList[this.lookUpIndex].selectedStageObjectForMappingType=this.selectedStageObjectForMappingType
      this.lookupMultiList[this.lookUpIndex].selectedStageObjectAttributeForMappingType=this.selectedStageObjectAttributeForMappingType
      this.lookupMultiList[this.lookUpIndex].query=this.query
      this.lookupMultiList[this.lookUpIndex].dnsType=this.selectedStageObjectDetails.dnsType
      
    }else{
    let item ={
      index:this.lookupMultiList.length,
      selectedStageObjectForMappingType:this.selectedStageObjectForMappingType,
      selectedStageObjectAttributeForMappingType:this.selectedStageObjectAttributeForMappingType,
      query:this.query,
      dnsType:this.selectedStageObjectDetails.dnsType
    }
    this.lookupMultiList.push(item);
  }
    this.createTransformationQuery();
    console.log(this.lookupMultiList);
     this.selectedStageObjectForMappingType=null;
      this.selectedStageObjectDetails=null;
      this.selectedStageObjectAttributeForMappingType=null;
      this.selectedStageObjectAttributesList=[];
      this.query='';
      this.lookUpIndex=null;
      this.lookupButtonName="Save"
      this.gridApi.api.setGridOption('rowData', this.lookupMultiList)
  }
   onGridReadyLookup(params){
    this.gridApi = params;
    //this.gridColumnApi = params.columnApi;
    //this.gridApi.sizeColumnsToFit();
    params.api.setGridOption('rowData', [])
    this.gridApi.api.setGridOption('rowData', this.lookupMultiList)
  }

  EditLookupIcon(event){
    this.lookupButtonName="Update";
    console.log(this.lookupMultiList);
    
    this.selectedStageObjectForMappingType=this.lookupMultiList[event.rowData.index].selectedStageObjectForMappingType
    this.selectedStageObjectAttributeForMappingType=this.lookupMultiList[event.rowData.index].selectedStageObjectAttributeForMappingType
    this.query=this.lookupMultiList[event.rowData.index].query
    this.lookUpIndex=event.rowData.index
    // this.ObjectsData
    console.log(this.stageObjectList);
    
     const stageObject=this.stageObjectList.filter(item=>item.objectname ==  this.selectedStageObjectForMappingType  && item.dnsType == this.lookupMultiList[event.rowData.index].dnsType);
           console.log(stageObject);
            this.selectedStageObjectDetails=stageObject[0]
            
      if(this.selectedStageObjectDetails.dnsType!="ValueMapping"){
           const attributesJson= stageObject[0].objectattributes ? JSON.stringify(JSON.parse(stageObject[0].objectattributes), null, 2):"";
        const columns=JSON.parse(attributesJson)
        // this.selectedStageObjectAttributesList=columns.datasets[0].columns;
       if(columns.datasets){
          this.selectedStageObjectAttributesList=columns.datasets[0].columns;
        }else{
          this.selectedStageObjectAttributesList=columns;
        }
      }else{
        this.spinner.start();
          this.valueMappingservice.retreiveFieldMapping(this.selectedStageObjectDetails.mappingTypeId).subscribe(response=>{
            if(response.error == true){
               this.spinner.stop();
            }else{
              let getdata:any=response
              let data:any = JSON.parse(getdata.mappedFieldsData)
              console.log(data);
              let headers=JSON.parse(getdata.mappedFields)
              if(headers){
                console.log(headers);
                this.valueMappingHeaders=[]
                this.valueMappingHeaders.push(...headers.SourceColumns)
                this.valueMappingHeaders.push(...headers.TargetColumns)
                // this.headersDataDetails=headers
                console.log(this.valueMappingHeaders);
                 this.selectedStageObjectAttributesList=this.valueMappingHeaders
              }
              // if(getdata.mappedFieldsData != null){
              //   let rowData=JSON.parse(getdata.mappedFieldsData)
              //   console.log(rowData);
              //   this.selectedStageObjectAttributesList=rowData;
              // }
               this.spinner.stop();
            }
          })
      }
  }
  deleteLookUpIcon(e){
     this.lookupMultiList.splice(e.rowData.index, 1);
  for(let i=0;i<this.lookupMultiList.length;i++){
    this.lookupMultiList[i].index=i
  }
  this.gridApi.api.setGridOption('rowData', this.lookupMultiList)
  this.createTransformationQuery();
  }

  searchableCodeListName(){
 if(this.codeListNamesDistinctData.length > 0){
        var columndata = []
      console.log(this.codeListNamesDistinctData)
      let selectedPropertyNameDetails;
      var headers={
        "CODELIST_NAME": "CODELIST_NAME",
      }
       columndata.push(headers)
       selectedPropertyNameDetails="CODELIST_NAME"
      let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
        width: "60%",
        autoFocus: false,
        disableClose: true,
        data: { 
          edata:this.codeListNamesDistinctData,
          page:"single",
          columns:columndata,
          selectedValue:[this.codelistName],
          selectedPropertyName:selectedPropertyNameDetails
        }
      });
       dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != undefined) {
        if(result.selectedRows.length > 0){
         this.codelistName=result.selectedRows[0].CODELIST_NAME;
        }else{
           this.codelistName=null;
        }
        
      }
      })
    }
}

onObjectSelectionClearValues(){
  this.mappingAttributeDTO={
      source_attribute:[],
      target_attribute:'',
      target_attribute_list:[],
      mapping_type:'',
      mapping_logic:'',
      exceptionquery:'',
      mappingObjectId:'',
      mappingObject:'',
      source_object_id:"",
      target_object_id:"",
      source_object:'',
      target_object:'',
      tenantId:'',
      codelistname:'',
      fieldorderid:'',
      bussinesslogic:'',
      codelist_value_type:'',
       reference_source:'',
    reference_target:'',
    reference_library:'',
    reference_vault_object:'',
    reference_global_object:'',
    reference_global_source_library:'',
    global_external_object:'',
    lookupMappingDetails:'',
    reference_Database_Object_Name:'',
    reference_Database_Object_Fetch_Partial:''
    }
    this.selectedSourceAttributeList=[]
    this.selectedTargetAttribute=''
    this.expressionDetails=""
    this.exceptionExpressionDetails=""
    this.freetextDetails = ""
    this.mappingType=''
    this.targetGrid.api.setGridOption('rowData', []);
    this.sourceGrid.api.setGridOption('rowData', []); 
    this.lookupButtonName="Save"
}

 searchableTargetObjectsForRefDBObjectName(){
         if(this.referenceTargetObjectsList.length > 0){
                var columndata = []
              var c = {
                "objectlabel": "Object Label",
                "objectname":"Object Name"
              } 
             columndata.push(c)
             let selectedList=[];
             if(this.selectedRefDBObjectNameList.length >0){
                selectedList = this.selectedRefDBObjectNameList;
             }
              let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
                width: "50%",
                autoFocus: false,
                disableClose: true,
                data: { 
                  edata:this.referenceTargetObjectsList,
                  page:"multiple",
                  columns:columndata,
                  selectedValue:selectedList,
                  selectedPropertyName:"objectname"
                }
              });
               dialogRef.afterClosed().subscribe(result => {
              console.log(result);
              if (result != undefined) {
                console.log(result.selectedRows);
                this.selectedRefDBObjectNameList=result.selectedRows.map((item: any) => item.objectname);
               this.selectedRefDBObjectNameListNames =result.selectedRows.map(item => item.objectname).join(',');
              }
              })
            }
      }
  
      
    searchableTargetObjectsForRefDBObjectNameFetchPartials(){
         if(this.referenceTargetObjectsList.length > 0){
                var columndata = []
              var c = {
                "objectlabel": "Object Label",
                "objectname":"Object Name"
              } 
             columndata.push(c)
             let selectedList=[];
             if(this.selectedRefDBObjectNameFetchPartialsList.length >0){
                selectedList = this.selectedRefDBObjectNameFetchPartialsList;
             }
              let dialogRef = this.dialog.open(CommonPopupSearchComponent, {
                width: "50%",
                autoFocus: false,
                disableClose: true,
                data: { 
                  edata:this.referenceTargetObjectsList,
                  page:"multiple",
                  columns:columndata,
                  selectedValue:selectedList,
                  selectedPropertyName:"objectname"
                }
              });
               dialogRef.afterClosed().subscribe(result => {
              console.log(result);
              if (result != undefined) {
                console.log(result.selectedRows);
                this.selectedRefDBObjectNameFetchPartialsList=result.selectedRows.map((item: any) => item.objectname);
               this.selectedRefDBObjectNameFetchPartialsListNames =result.selectedRows.map(item => item.objectname).join(',');
              }
              })
            }
      }
onExpressionChange(value: string): void {
  console.log(value);
  
}
}
